import appConfig from './app'

const playcanvasConfig = {
  stacknloadGameURL: appConfig.playcanvas.stacknload,
  multGameURL: appConfig.playcanvas.multgame,
  treasureTrailURL: appConfig.playcanvas.treasureTrail,
  windSurferURL: appConfig.playcanvas.windSurfer,
}
export default playcanvasConfig
